import Test from "./Test";

export default class AppHealthTest extends Test {
  constructor(api) {
    super(api, "App Health Test");
  }

  async init() {
    this.message = "Fetching app health details...";
    // Simulate initialization delay
    return [{ name: "Health", link: "/" }];
  }

  async exec() {
    let success = true;
    try {
      await this.api.get("/");
    } catch (error) {
      console.error("AppHealthTest exec", error);
      success = false;
    }
    return {
      success,
      message: success ? "App health check passed." : "App health check failed."
    };
  }
}
